import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { ignoreElements, map, withLatestFrom } from 'rxjs/operators';
import { UPDATE_TRAC_PAGE_FIELD } from '../../../tracpage/actions';
import { Actions } from '@webapp/store/actions';
import { rudderanalytics } from '@webapp/utils/rudderstack/init';
import AppState from '@webapp/store/state';

export const trackTracpageFieldUpdated = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(UPDATE_TRAC_PAGE_FIELD),
    withLatestFrom(state$),
    map(([, state]) => {
      const artistPage = state.tracpage.artistPage;
      rudderanalytics.group('tracPage Updated (Group)', {
        theme: artistPage.theme,
        artist_id: state.artist.active?.id,
        artist_name: state.artist.active?.name,
        custom_background: artistPage.background,
        links_headers: artistPage.links.map((l) => {
          return {
            url: l.url,
            type: l.type,
            title: l.title,
          };
        }),
      });
    }),
    ignoreElements()
  );
